import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=66ee19b4&"
import script from "./Import.vue?vue&type=script&lang=ts&"
export * from "./Import.vue?vue&type=script&lang=ts&"
import style0 from "./Import.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports